import { Backdrop, Box, CircularProgress, useTheme } from '@mui/material';
import { downGradeOfferModalSxs } from './newChangePlan';
import { buySearchCreditModalSxs } from 'src/content/keywordResearch/keywordResearchCSS';
import { isLocalSeoUser } from 'src/common/config/FunctionHelper';
import { useDownGradeOffer } from '../hooks/useDownGradeOffer';
import OfferModalHeader from './OfferModalHeader';
import OfferComponentRenderer from './OfferComponentRenderer';
import OfferModalAlerts from './OfferModalAlerts';
import OfferModalButtons from './OfferModalButtons';
import OfferModalFooter from './OfferModalFooter';

export const DownGradeOfferModal = ({
  handleCloseDownGradeOfferModal = () => {},
  selectedPlanName = '',
  handleDowngrade = () => {},
  selectedOption = '',
  otherReason = '',
  missingFeature = '',
  loading = false,
  handleErrorSnackBarClose = () => {},
  handCloseModal = () => {},
  handleChangePlanModal = () => {},
  errorMessage = null,
  changePlanSuccess = false,
  isFromDeactivate = false,
  isSuccessfullySubmitted = false,
  error = '',
  successMessage = '',
  selectedTimeLine = ''
}) => {
  const theme = useTheme();
  const styles = buySearchCreditModalSxs(theme);
  const isLocalSeo = isLocalSeoUser();

  const {
    facingBugsFeatureFromOfferModal,
    setFacingBugsFeatureFromOfferModal,
    isFacingBugsFieldErrorFromOfferModal,
    setIsFacingBugsFieldErrorFromOfferModal,
    isMinCharFacingBugsErrorFromOfferModal,
    setIsMinCharFacingBugsErrorFromOfferModal,
    isOfferProcess,
    setIsOfferApplied,
    handleContinue
  } = useDownGradeOffer({ selectedOption, handleDowngrade });

  const facingBugsState = {
    isFacingBugsFieldErrorFromOfferModal,
    setIsFacingBugsFieldErrorFromOfferModal,
    isMinCharFacingBugsErrorFromOfferModal,
    setIsMinCharFacingBugsErrorFromOfferModal,
    facingBugsFeatureFromOfferModal,
    setFacingBugsFeatureFromOfferModal
  };

  return (
    <>
      <Backdrop
        sx={{
          color: 'var(--color-white)',
          zIndex: (theme) => theme.zIndex.drawer + 1
        }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box sx={downGradeOfferModalSxs?.mainBoxSx}>
        <OfferModalHeader
          isLocalSeo={isLocalSeo}
          isFromDeactivate={isFromDeactivate}
          handleCloseDownGradeOfferModal={handleCloseDownGradeOfferModal}
        />

        <Box sx={downGradeOfferModalSxs?.offerBoxSx}>
          <OfferComponentRenderer
            selectedOption={selectedOption}
            selectedTimeLine={selectedTimeLine}
            handCloseModal={handCloseModal}
            handleChangePlanModal={handleChangePlanModal}
            isFromDeactivate={isFromDeactivate}
            setIsOfferApplied={setIsOfferApplied}
            facingBugsState={facingBugsState}
            missingFeature={missingFeature}
            otherReason={otherReason}
          />
        </Box>

        <OfferModalAlerts
          changePlanSuccess={changePlanSuccess}
          errorMessage={errorMessage}
          handleErrorSnackBarClose={handleErrorSnackBarClose}
          handCloseModal={handCloseModal}
          handleChangePlanModal={handleChangePlanModal}
          isSuccessfullySubmitted={isSuccessfullySubmitted}
          isFromDeactivate={isFromDeactivate}
          successMessage={successMessage}
          error={error}
        />

        <OfferModalButtons
          isLocalSeo={isLocalSeo}
          isFromDeactivate={isFromDeactivate}
          isOfferProcess={isOfferProcess}
          handleCloseDownGradeOfferModal={handleCloseDownGradeOfferModal}
          handleContinue={handleContinue}
        />

        {selectedOption === 'Hiring someone to do it for me instead' && (
          <OfferModalFooter styles={styles} />
        )}
      </Box>
    </>
  );
};
